import React, { useContext } from 'react';
import ActionButton from "../../../../Components/Buttons/ActionButton";
import { BookingFormContext } from "../BookingFormProvider";
import BookingFormTermsConditions from "./BookingFormTermsConditions";

const BookingFormSubmitSection = (props) => {

    const {
        bookingInProgress,
        isSubmitDisabled,
        onSubmitClick,

        editBookingId,
    } = useContext(BookingFormContext);

    return (
        <section className="section form-container full">
            <BookingFormTermsConditions/>

            {editBookingId
                ? <>
                    <button
                        type="button"
                        className="button secondary"
                        onClick={props.onCancel}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="button primary pull-right"
                        onClick={onSubmitClick}
                        disabled={isSubmitDisabled()}
                    >
                        Save
                    </button>
                </>
                : <ActionButton
                    type="button"
                    title="Book now"
                    className="button primary expanded"
                    onClick={onSubmitClick}
                    isDisabled={isSubmitDisabled()}
                    animateOnClick
                    isActive={bookingInProgress}
                    preventMultipleClicks
                />
            }

        </section>
    );
};

BookingFormSubmitSection.propTypes = {};

BookingFormSubmitSection.defaultProps = {};

export default BookingFormSubmitSection;
